var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarWithoutOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17869_4533)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17869_4533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 36,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-90 4 36)",
    fill: "#1F286B",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_17869_4533)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_17869_4533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1564 29.9139L34.2171 29.9139C35.297 29.9139 36.2747 29.544 36.9823 28.946C38.1016 28 38.1277 26.8293 38.1277 26.6093C38.5993 24.8889 39.9994 22.6425 40 20.0063C40.0007 17.3643 38.6 15.1135 38.1277 13.3907C38.1277 11.5657 36.3768 10.0861 34.2171 10.0861L29.1564 10.0861C29.0262 9.23273 28.2905 8 27.3939 8L27.0787 8C26.7911 8 26.558 8.19696 26.558 8.44L26.8157 10.0861L4.91127 10.0861C2.75148 10.0861 6.08793e-05 11.5657 6.07995e-05 13.3907L6.02217e-05 26.6093C6.01419e-05 28.4343 2.75148 29.9139 4.91127 29.9139L26.8157 29.9139L26.558 31.56C26.558 31.803 26.7911 32 27.0787 32L27.3939 32C28.2905 32 29.0262 30.7672 29.1564 29.9139Z",
    fill: "#1F286B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.6035 26.9242C22.3373 26.8828 22.1607 26.5386 22.2514 26.219C22.7017 24.6329 23.16 23.0284 23.151 19.9162C23.1422 16.8859 22.6933 15.3443 22.2496 13.7873C22.1593 13.4703 22.3281 13.1312 22.592 13.0874C24.7383 12.7309 26.8033 12.2784 28.9268 11.9752C29.1116 11.9488 29.2902 12.0722 29.3628 12.289C29.9007 13.8968 30.601 16.5875 30.601 20.0069C30.601 23.4196 29.9035 26.1063 29.366 27.7152C29.2921 27.9365 29.1056 28.0572 28.9179 28.0224C26.8187 27.6324 25.0632 27.3065 22.6035 26.9242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2649 26.1455C10.4691 26.1088 10.6046 25.8033 10.5349 25.5196C10.1895 24.1119 9.83795 22.6879 9.84488 19.9257C9.85163 17.2362 10.196 15.868 10.5363 14.4861C10.6056 14.2047 10.4762 13.9037 10.2737 13.8648C8.62716 13.5485 7.66239 13.1468 6.03334 12.8778C5.89159 12.8543 5.75455 12.9638 5.69889 13.1563C5.28622 14.5833 4.74905 16.9713 4.74905 20.0062C4.74905 23.0351 5.28409 25.4196 5.69643 26.8476C5.75314 27.044 5.89619 27.1511 6.04018 27.1202C7.65058 26.7741 8.37793 26.4849 10.2649 26.1455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.843 11.0095L22.0483 12.3324C21.6494 12.4424 21.2363 12.512 20.8179 12.5396L12.7873 13.0691C12.2518 13.1044 11.7132 13.0697 11.1902 12.9662L6.26392 11.9916L7.18198 11.2891C7.54222 11.0135 8.01087 10.8608 8.49685 10.8608L26.815 10.8608C26.9176 10.8608 26.9406 10.9826 26.843 11.0095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.843 28.9904L22.0483 27.6676C21.6494 27.5575 21.2363 27.488 20.8179 27.4604L12.7873 26.9309C12.2518 26.8956 11.7132 26.9302 11.1902 27.0337L6.26392 28.0083L7.18198 28.7108C7.54222 28.9864 8.01087 29.1391 8.49685 29.1391L26.815 29.1391C26.9176 29.1391 26.9406 29.0174 26.843 28.9904Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17869_4533",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_17869_4533"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.156863 0 0 0 0 0.419608 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17869_4533"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17869_4533",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_17869_4533",
    x: 0,
    y: 8,
    width: 40,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17869_4533"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17869_4533",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17869_4533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_17869_4533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 39.9999,
    fill: "white",
    transform: "translate(40 8) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarWithoutOrder);
export default __webpack_public_path__ + "static/media/car-without-order.7f74a72b.svg";
export { ForwardRef as ReactComponent };